import {
  useEffect,
  useState
} from 'react';

import {
  useNavigate
} from 'react-router-dom';

import {
  isNativeApp
} from './utils/nativeApp';

import {
  getNativeDeviceToken
} from './utils/nativeDeviceAuth';

import {
  getInstructorDeviceToken
} from './instructor-app/instructorNativeDeviceAuth';


const ACTIVE_ROLE_KEY =
  'veritasActiveRole';


function validSession(key) {
  try {
    const raw =
      localStorage.getItem(key);

    if (!raw) {
      return false;
    }

    const value =
      JSON.parse(raw);

    if (
      value?.expiresAt &&
      Date.now() > value.expiresAt
    ) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
}


export default function UnifiedLogin() {
  const navigate =
    useNavigate();

  const [
    identifier,
    setIdentifier
  ] =
    useState('');

  const [
    checking,
    setChecking
  ] =
    useState(true);


  useEffect(() => {
    let cancelled = false;

    async function restoreRoute() {
      const lastRole =
        localStorage.getItem(
          ACTIVE_ROLE_KEY
        );

      const studentSignedOut =
        localStorage.getItem(
          'studentNativeSignedOut'
        ) === 'true';

      const instructorSignedOut =
        localStorage.getItem(
          'instructorNativeSignedOut'
        ) === 'true';

      let studentAvailable =
        !studentSignedOut &&
        validSession(
          'studentSession'
        );

      let instructorAvailable =
        !instructorSignedOut &&
        validSession(
          'instructorMobileSession'
        );

      if (isNativeApp()) {
        const [
          studentToken,
          instructorToken
        ] =
          await Promise.all([
            studentSignedOut
              ? null
              : getNativeDeviceToken()
                  .catch(() => null),

            instructorSignedOut
              ? null
              : getInstructorDeviceToken()
                  .catch(() => null)
          ]);

        studentAvailable =
          studentAvailable ||
          Boolean(studentToken);

        instructorAvailable =
          instructorAvailable ||
          Boolean(instructorToken);
      }

      if (cancelled) {
        return;
      }

      if (
        lastRole === 'student' &&
        studentAvailable
      ) {
        navigate(
          '/student',
          { replace: true }
        );
        return;
      }

      if (
        lastRole === 'instructor' &&
        instructorAvailable
      ) {
        navigate(
          '/instructor',
          { replace: true }
        );
        return;
      }

      if (
        studentAvailable &&
        !instructorAvailable
      ) {
        navigate(
          '/student',
          { replace: true }
        );
        return;
      }

      if (
        instructorAvailable &&
        !studentAvailable
      ) {
        navigate(
          '/instructor',
          { replace: true }
        );
        return;
      }

      setChecking(false);
    }

    restoreRoute();

    return () => {
      cancelled = true;
    };
  }, [navigate]);


  function submit(event) {
    event.preventDefault();

    const clean =
      String(
        identifier || ''
      ).trim();

    if (!clean) {
      return;
    }

    const role =
      clean.includes('@')
        ? 'instructor'
        : 'student';

    localStorage.setItem(
      ACTIVE_ROLE_KEY,
      role
    );

    navigate(
      '/' +
        role +
        '?login=' +
        encodeURIComponent(clean),
      {
        replace: true
      }
    );
  }


  if (checking) {
    return null;
  }


  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: '24px',
        background: '#f4f6f8',
        fontFamily:
          'Arial, Helvetica, sans-serif'
      }}
    >
      <section
        style={{
          width: 'min(100%, 430px)',
          background: 'white',
          borderRadius: '14px',
          padding: '28px',
          boxShadow:
            '0 12px 35px rgba(36,59,83,0.12)'
        }}
      >
        <div
          style={{
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            fontSize: '11px',
            fontWeight: 800,
            color: '#627d98'
          }}
        >
          Tunghai Honors
        </div>

        <h1
          style={{
            margin: '6px 0 8px',
            color: '#243b53',
            fontSize: '28px'
          }}
        >
          Sign In
        </h1>

        <p
          style={{
            margin: '0 0 18px',
            color: '#627d98',
            lineHeight: 1.5
          }}
        >
          Enter your Student ID or Faculty Email.
        </p>

        <form onSubmit={submit}>
          <label
            style={{
              display: 'block',
              fontSize: '13px',
              fontWeight: 800,
              color: '#243b53',
              marginBottom: '7px'
            }}
          >
            Student ID or Faculty Email
          </label>

          <input
            type="text"
            value={identifier}
            onChange={
              event =>
                setIdentifier(
                  event.target.value
                )
            }
            autoCapitalize="none"
            autoCorrect="off"
            autoFocus
            required
            style={{
              width: '100%',
              boxSizing: 'border-box',
              border:
                '1px solid #bcccdc',
              borderRadius: '8px',
              padding: '12px 13px',
              fontSize: '16px',
              background: 'white',
              color: '#243b53'
            }}
          />

          <button
            type="submit"
            style={{
              width: '100%',
              marginTop: '18px',
              border: 0,
              borderRadius: '9px',
              background: '#243b53',
              color: 'white',
              padding: '14px 16px',
              fontWeight: 800,
              fontSize: '16px'
            }}
          >
            Continue
          </button>
        </form>
      </section>
    </main>
  );
}
